import router from "./router";
import store from "./store";
import cookies from "vue-cookies";
import { Message } from "element-ui";
import getPageTitle from "@/utils/get-page-title";
import loginAPI from "@/api/login";

router.beforeEach((to, from, next) => {
  if (to.query && to.query.token) {
    const token = to.query.token;
    console.log(token);
    cookies.set("ACCESS_TOKEN", token);
    
    store.commit("user/SET_TOKEN", token);
    loginAPI.getUserInfo().then(res => {
      store.dispatch("user/setUserInfo", res.user);
    });
    // VueCookies.set("ACCESS_TOKEN", token);
  }
  document.title = getPageTitle(to.meta.title, to.path);

  // let token = store.state.user.token;

  //   if (to.path === "/user-login") {
  //     if (VueCookies.isKey("ACCESS_TOKEN")) {
  //       Message("您以登录，请先退出登录");
  //       next({ path: "/" });
  //     } else {
  //       next();
  //     }
  //   } else {
  //     next();
  //   }
  next();
});

// router.afterEach(() => {});
